if (!customElements.get('cooliooli-mobile-purchase')) {
  customElements.define('cooliooli-mobile-purchase', class extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('section');
      this.form = document.getElementById(`product-form-${this.dataset.section}`);
      this.originalButton = this.form?.querySelector('[name="add"]');
      this.picker = this.section.querySelector('variant-radios, variant-selects');
      this.sizeGroup = this.picker?.querySelector('[data-option-name="Size"], [data-option-name="size"]');
      this.action = this.querySelector('button');
      this.chosen = !this.sizeGroup || new URL(location.href).searchParams.has('variant');
      if (!this.form || !this.originalButton) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.section.addEventListener('click', event => {
        const label = event.target.closest('label');
        const input = label ? document.getElementById(label.htmlFor) : event.target;
        if (this.sizeGroup?.contains(input) && input.matches('input[type="radio"]') && !input.classList.contains('disabled')) {
          this.chosen = true;
          this.sync();
        }
      }, {signal});
      this.section.addEventListener('change', event => {
        if (this.sizeGroup?.contains(event.target)) this.chosen = true;
        this.sync();
      }, {signal});
      this.form.addEventListener('submit', event => {
        if (!this.chosen) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.chooseSize();
        }
      }, {capture:true, signal});
      this.action.addEventListener('click', () => {
        if (!this.chosen) this.chooseSize();
        else if (!this.originalButton.disabled && this.originalButton.getAttribute('aria-disabled') !== 'true') this.form.requestSubmit(this.originalButton);
      }, {signal});
      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this.originalButton, {attributes:true, childList:true, subtree:true});
      this.priceObserver = new MutationObserver(() => this.sync());
      const price = document.getElementById(`price-${this.dataset.section}`);
      if (price) this.priceObserver.observe(price, {childList:true, subtree:true});
      this.intersection = new IntersectionObserver(entries => {
        this.toggleAttribute('data-inline-visible', entries[0].isIntersecting);
      }, {threshold:0});
      this.intersection.observe(this.originalButton);
      this.hidden = false;
      this.sync();
    }
    chooseSize() {
      if (!this.sizeGroup) return;
      this.sizeGroup.scrollIntoView({behavior:'smooth', block:'center'});
      this.sizeGroup.querySelector('input:not(.disabled)')?.focus({preventScroll:true});
      this.sizeGroup.querySelector('.cooliooli-size-prompt')?.removeAttribute('hidden');
    }
    sync() {
      const busy = this.originalButton.disabled || this.originalButton.getAttribute('aria-disabled') === 'true';
      this.action.disabled = busy;
      this.action.textContent = !this.chosen && !busy ? this.dataset.chooseSize : this.originalButton.querySelector('span').textContent.trim();
      const priceContainer = document.getElementById(`price-${this.dataset.section}`);
      const price = priceContainer?.querySelector('.price--on-sale .price-item--sale') || priceContainer?.querySelector('.price-item--regular, .price-item');
      if (price) this.querySelector('.cooliooli-mobile-price').textContent = price.textContent.trim();
      const selected = [...this.picker?.querySelectorAll('input:checked') || []].map(input => input.value).join(' / ');
      this.querySelector('.cooliooli-selected-options').textContent = selected;
      this.querySelector('.cooliooli-selected-options').hidden = !this.chosen;
      this.action.setAttribute('aria-label', `${this.action.textContent}${this.chosen && selected ? ` — ${selected}` : ''}`);
      this.sizeGroup?.classList.toggle('cooliooli-needs-size', !this.chosen);
      if (this.chosen) this.sizeGroup?.querySelector('.cooliooli-size-prompt')?.setAttribute('hidden', '');
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.priceObserver?.disconnect();
      this.intersection?.disconnect();
    }
  });
}
